/**
 * @generated SignedSource<<fc19392680bd0400e51256afeff64a82>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useAuthenticated_candidate$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "useAuthenticated_candidate";
};
export type useAuthenticated_candidate$key = {
  readonly " $data"?: useAuthenticated_candidate$data;
  readonly " $fragmentSpreads": FragmentRefs<"useAuthenticated_candidate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useAuthenticated_candidate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Candidate",
  "abstractKey": null
};

(node as any).hash = "7f1e90c4d536c0c6b6faf062ada90b14";

export default node;
